import styles from './FooterLegalLinksContainer.module.scss';
import cx from 'classnames';

interface FooterLegalLinksContainerProps {
  children: React.ReactNode;
  isCheckout?: boolean;
}

export const FooterLegalLinksContainer = ({
  children,
  isCheckout = false,
}: FooterLegalLinksContainerProps) => (
  <div
    className={cx('d-flex',  [styles['footer__legal__links-container']], {
      [styles['footer__legal__links-container_border']]: !isCheckout,
    })}
  >
    {children}
  </div>
);
